import { DropDownList } from '@syncfusion/ej2-dropdowns';

import { CompanyType } from '@/shared/types/enum';

import { getControl } from '@/front/editable/state';
import { listen } from '@/front/event';

listen('editablesReady', () => {
  [...document.querySelectorAll('.editable[data-field="companyType"]')]
    .map((editable) => editable as HTMLDivElement)
    .forEach((editable) => {
      const form = editable.closest('form') as HTMLFormElement;

      const companyTypeDropDownList = getControl(editable.id) as DropDownList;

      const refresh = (...companyTypes: CompanyType[]) => {
        const selected = companyTypes.includes(companyTypeDropDownList.value as CompanyType);

        [...form.querySelectorAll(`[data-company-types="${companyTypes.join(',')}"]`)]
          .map((childContainer) => childContainer as HTMLElement)
          .forEach((childContainer) => {
            childContainer.classList.toggle('d-none', !selected);

            const childEditable = childContainer.querySelector('.editable') as HTMLDivElement;

            if (childEditable) {
              (getControl(childEditable.id) as { enabled: boolean }).enabled = selected;
            }
          });
      };

      if (companyTypeDropDownList) {
        refresh(CompanyType.LimitedCompany, CompanyType.LimitedLiabilityPartnership);
        refresh(CompanyType.SoleTrader, CompanyType.Partnership);

        companyTypeDropDownList.addEventListener('change', () => {
          refresh(CompanyType.LimitedCompany, CompanyType.LimitedLiabilityPartnership);
          refresh(CompanyType.SoleTrader, CompanyType.Partnership);
        });
      }
    });
});
